import { Provider } from '@angular/core';
import { ENSURE_FRESH_CREDENTIALS } from '@marina/api-client';
import { AuthService } from './services/auth.service';

/**
 * Lets non-HTTP clients wait for current credentials.
 *
 * Add to an app's providers. Without it, SignalR hub connections negotiate with whatever cookie
 * happens to be in the jar — which, on a tab reopened after the access token lapsed, is an expired
 * one: a 401 from every hub, and a "Connection lost" dialog for what is only a routine refresh.
 */
export const AUTH_READINESS_PROVIDERS: Provider[] = [
  {
    provide: ENSURE_FRESH_CREDENTIALS,
    useFactory: (auth: AuthService) => () => auth.ensureFreshCredentials(),
    deps: [AuthService],
  },
];
